import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs } from 'vue';
import apis from "@/api";
export default {
  name: "UsersOfRole",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: String
    }
  },
  setup(props, context) {
    const data = reactive({
      loading: false,
      tableData: [],
      queryParam: {},
      paginationObj: {
        pageSize: 5
      }
    });
    const loadUserPage = () => {
      data.loading = true;
      apis.userPageOfRoleId({
        ...data.queryParam,
        ...data.paginationObj
      }).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleSizeChange = val => {
      data.paginationObj.pageSize = val;
      loadUserPage();
    };
    const handleCurrentChange = val => {
      data.paginationObj.pageNo = val;
      loadUserPage();
    };
    const close = () => {
      context.emit('update:visible', false);
    };
    const initDialog = () => {
      data.queryParam.roleId = props.roleId;
      loadUserPage();
    };
    return {
      ...toRefs(data),
      handleSizeChange,
      handleCurrentChange,
      initDialog,
      close
    };
  }
};